import { useState } from 'react';
import { useNavigate } from 'react-router';

import { Button } from '@/components/Button';
import { CreateUpdateServiceProvider } from '@/pages/ServiceProviders/ServiceProviderForms';
import { usePerson } from '@/store/persons/person.store';
import { refreshAfterAccountSwitch } from '@/store/service-providers/refresh-active-account';

import CreateVesselSheet from '../CreateSheet/CreateVesselSheet';
import Modal from '../Modal/Modal';

import s from './AddAccountFlow.module.scss';

type AddAccountFlowProps = {
  open: boolean;
  onClose: () => void;
};

export const AddAccountFlow = ({ open, onClose }: AddAccountFlowProps) => {
  const navigate = useNavigate();
  const { me } = usePerson();
  const [isCreateServiceProviderOpened, setIsCreateServiceProviderOpened] = useState(false);
  const [isCreateVesselOpened, setIsCreateVesselOpened] = useState(false);

  return (
    <>
      <Modal open={open} title="Add Account" onClose={onClose}>
        <section className={s.addAccountModal}>
          <p>What would you like to add?</p>
          <div className={s.addAccountOptions}>
            <Button
              onClick={() => {
                onClose();
                setIsCreateVesselOpened(true);
              }}
            >
              Vessel
            </Button>
            <Button
              onClick={() => {
                onClose();
                setIsCreateServiceProviderOpened(true);
              }}
            >
              Service Provider
            </Button>
          </div>
        </section>
      </Modal>
      {isCreateServiceProviderOpened && (
        <CreateUpdateServiceProvider
          onClose={() => setIsCreateServiceProviderOpened(false)}
          onSuccess={() => {
            setIsCreateServiceProviderOpened(false);
            me();
            navigate('/dashboard', { replace: true, state: null });
          }}
          firstService={false}
          showMarina
        />
      )}
      {isCreateVesselOpened && (
        <CreateVesselSheet
          title="Add Vessel"
          open
          onClose={() => setIsCreateVesselOpened(false)}
          onSuccess={async () => {
            setIsCreateVesselOpened(false);
            await refreshAfterAccountSwitch();
            navigate('/dashboard', { replace: true });
          }}
        />
      )}
    </>
  );
};
